import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-accessory-description',
  templateUrl: './accessory-description.component.html',
  styleUrl: './accessory-description.component.scss',
})
export class AccessoryDescriptionComponent implements OnInit {
@Input() overview : {
  title: string;
  subtitle: string;
  description?: string;
  images?: string[];
  content: {
    title: string;
    description?: string;
    itemList?: string[] | { title: string; sublist?: string[] }[];
    tableRows?: string[][];
    notes?: string;
  }[]
};

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) { }

  ngOnInit() {
    this.overview = this.data.overview;
  }
}
